import { h, Host, Component, Prop, Element } from '@stencil/core';

@Component({
  shadow: false,
  scoped: true,
  styleUrl: 'igws-animated-hero.less',
  tag: 'igws-animated-hero',
})
export class AnimatedHeroComponent {
  @Element() el!: HTMLIgwsAnimatedHeroElement;

  /**
   * Background image for container
   */
  @Prop() image!: string;

  /**
   * Check if image is defined
   */
  @Prop() hasImage!: boolean;

  /**
   * Background color for container
   */
  @Prop() backgroundColor!: string;

  /**
   * Check if background color is defined
   */
  @Prop() hasBackgroundColor!: boolean;

  /**
   * Mp4 video link
   */
  @Prop() video!: string;

  /**
   * Check if main video is defined
   */
  @Prop() hasVideo!: boolean;

  /**
   * Alternative video link
   */
  @Prop() videoAlt!: string;

  /**
   * Check if alternative video is defined
   */
  @Prop() hasVideoAlt!: boolean;

  /**
   * Shade color with opacity
   */
  @Prop() videoScreen!: string;

  /**
   * Check if video screen is defined
   */
  @Prop() hasVideoScreen!: boolean;

  async componentDidLoad() {
    const video: HTMLVideoElement | null = this.el.querySelector('.animated-hero__video');
    if (video) {
      try {
        await video.play();
        video.classList.remove('no-autoplay');
      } catch (err) {
        video.classList.add('no-autoplay');
      }
    }
  }

  render() {
    const styles = {};
    if (this.hasImage) {
      styles['background-image'] = `url(${this.image})`;
    }
    if (this.hasBackgroundColor) {
      styles['background-color'] = this.backgroundColor;
    }

    return (
      <Host style={styles}>
        <div class="animated-hero__container">
          {this.hasVideo || this.hasVideoAlt
            ? [
                // muted autoplay supported by Safari on iOS 10+ and Chrome for Android 53+
                <video loop autoplay muted playsinline class="animated-hero__video no-autoplay">
                  {this.hasVideoAlt ? <source src={this.videoAlt} type="video/webm"></source> : null}
                  {this.hasVideo ? <source src={this.video} type="video/mp4"></source> : null}
                </video>,
                this.hasVideoScreen ? <div class="shade" style={{ background: this.videoScreen }}></div> : null,
              ]
            : null}

          <div class="animated-hero__content">
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
